__turbopack_context__.v({
  "fill": "Section-module-scss-module__wsloJq__fill",
  "grey": "Section-module-scss-module__wsloJq__grey",
  "sectionHeader": "Section-module-scss-module__wsloJq__sectionHeader",
  "sectionLabel": "Section-module-scss-module__wsloJq__sectionLabel",
});
